import { Image } from "react-bootstrap"

import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import watchResolvedImage from "../../assets/images/watch-resolved.png"
import watchImage from "../../assets/images/watch.png"

interface WatchCellProps {
  row: OrderResultRecord
}

function WatchCell(props: WatchCellProps) {
  const { row } = props

  return (
    <td className="alert-icons" key={`alert-${row.TestDetailID}-${row.TestDetailClinicalID}`}>
      {row.TestEventAlert?.Watch && (
        <div>
          {!row.TestEventAlert.WatchResolved && <Image src={watchImage} title="Watch Alert" />}
          {row.TestEventAlert.WatchResolved && <Image src={watchResolvedImage} title="Watch Resolved" />}
        </div>
      )}
    </td>
  )
}

export default WatchCell
